import { ReactElement } from "react";
import {
  Datagrid,
  List,
  ListProps,
  TextField,
  EditButton,
  useListContext,
  CreateButton,
  FunctionField,
  useDataProvider,
  useNotify,
  useRefresh,
} from "react-admin";
import { Typography } from "@material-ui/core";
import Switch from "@mui/material/Switch";
import { Box } from "@mui/material";

const Empty = () => {
  const { basePath, resource } = useListContext();
  return (
    <Box style={{ padding: 20 }} textAlign="center" m={1}>
      <Typography variant="h4" paragraph>
        No Servers available
      </Typography>
      <Typography variant="body1">Do you want to add one ?</Typography>
      <div style={{ padding: 10 }}></div>
      <CreateButton basePath={basePath} />
    </Box>
  );
};

const ResourceList = (props: ListProps): ReactElement => {
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();

  return (
    <div style={{ paddingLeft: 25 }}>
      <List title="Company" empty={<Empty />} {...props} perPage={10}>
        <Datagrid>
          {/* <TextField source='_id' label='Name' /> */}
          <TextField source="name" label="Name" />
          <TextField source="apikey" label="Api Key" />
          <TextField source="encryption_key" label="Encryption key" />
          <FunctionField label="Company Code" render={(record: any) => record.id} />
          <EditButton />
        </Datagrid>
      </List>
    </div>
  );
};

export default ResourceList;
